/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import { FaPlus } from "@react-icons/all-files/fa/FaPlus";
import { FaMinus } from "@react-icons/all-files/fa/FaMinus";
import LazyImage from "../../../../../../hooks/lazy-image";
import useTranslate from "~hooks/useTranslate/useTranslate";
import Button from "../../../../../atoms/button/button";
import {
  getAltText,
  imagePrettyUrl,
} from "../../../../../../helpers/getters.mjs";
import styles from "./style.module.scss";

export default function TemplateOne({
  item,
  readMore = false,
  scrollableContent = false,
  buttonType = "secondary",
  buttonSize = "m",
  width = 104,
  height = 104,
}) {  
  const [showMore, setShowMore] = useState(false);
  const TitleTag = item?.title_tag || "label";
  const btnText = useTranslate("read_review_spotlight", "Read review");
  const readMoreText = useTranslate("read_more", "Read more");
  const readLessText = useTranslate("read_less", "Read less");

  
  return (
    <div className={styles.item}>
      <div className={styles.topSection}>
        {item?.image && (
          <LazyImage
            width={width}
            height={height}
            src={imagePrettyUrl(item?.image, width, height)}
            alt={getAltText(item?.image_object, item?.label)}
          />
        )}
        {item?.label && <TitleTag>{item?.label}</TitleTag>}
        {item?.text && (
          <div
            tabIndex={`${scrollableContent ? 0 : -1}`}
            className={`${styles.desc} ${
              scrollableContent ? styles.scroll : ""
            } ${
              readMore && !scrollableContent && !showMore ? styles.readMore : ""
            }`}
            dangerouslySetInnerHTML={{ __html: item?.text }}
          />
        )}
        {readMore && !scrollableContent && (
          <span
            onClick={() => setShowMore(!showMore)}
            className={styles.readMoreBtn}
          >
            {!showMore ? (
              <>
                {readMoreText}
                <FaPlus size={16} />
              </>
            ) : (
              <>
                {readLessText}
                <FaMinus size={16} />
              </>
            )}
          </span>
        )}
      </div>

      {item?.link?.value && (
        <Button
          icon={<FaArrowRight />}
          buttonType={buttonType}
          buttonSize={buttonSize}
          isInternalLink={item?.link?.type !== "external"}
          targetBlank={item?.link?.type !== "page"}
          to={item?.link?.value}
          btnText={item?.link_text || btnText}
        />
      )}
    </div>
  );
}

TemplateOne.propTypes = {
  item: PropTypes.shape({
    link: PropTypes.shape({
      value: PropTypes.string,
      type: PropTypes.string,
    }),
    title_tag: PropTypes.string,
    image: PropTypes.string,
    link_text: PropTypes.string,
    label: PropTypes.string,
    text: PropTypes.string,
    image_object: PropTypes.shape({
      alt: PropTypes.string,
    }),
  }).isRequired,
  readMore: PropTypes.bool,
  scrollableContent: PropTypes.bool,
  buttonType: PropTypes.string,
  buttonSize: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
